import { render, staticRenderFns } from "./suppressions.vue?vue&type=template&id=63fa9217&"
import script from "./suppressions.vue?vue&type=script&lang=js&"
export * from "./suppressions.vue?vue&type=script&lang=js&"
import style0 from "./suppressions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports